import useOptions from "../useSelectOptions/useSelectOptions";
import { mapAdventureOptions } from "../../../utils/mapDataToOptions";

const useAdventureOptions = (endpoint) => {
  return useOptions(endpoint, mapAdventureOptions);
};

export default useAdventureOptions;
